import { Component, inject } from "@angular/core";

import { toSignal } from "@angular/core/rxjs-interop";
import { v4 } from "uuid";

import { CallToActionComponent } from "@hermes/aphrodite-call-to-action";
import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";
import {
    FeatureFlagFacade,
    FOOTER_NEWSLETTER_REMOVAL,
} from "@hermes/hermes-web-states-flipper-state";

import { TrayFacade } from "@hermes/hermes-web-states-tray-state";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";
import { UserAgentPlatformService } from "@hermes/utils-generic-services-user-agent-platform";

import { FooterClickEvent } from "../../events/click.event";

@Component({
    selector: "h-footer-newsletter-deprecated",
    imports: [
        SvgIconComponent,
        CallToActionComponent,
        SrOnlyNoSnippetDirective,
    ],
    templateUrl: "./footer-newsletter-deprecated.component.html",
    styleUrls: ["./footer-newsletter-deprecated.component.scss"],
})
export class FooterNewsletterDeprecatedComponent {
    private analyticsService = inject(AnalyticsService);
    private featureFlagFacade = inject(FeatureFlagFacade);
    private trayFacade = inject(TrayFacade);

    public isNewsletterRemove = toSignal(
        this.featureFlagFacade.isActivated(FOOTER_NEWSLETTER_REMOVAL),
        { initialValue: false },
    );

    public readonly isMobile = inject(UserAgentPlatformService).isMobileSignal;

    public handleClickOnSubscribeButton($event: Event): void {
        $event.stopPropagation();

        this.trayFacade.openTray({
            hasOverlay: true,
            hasCategoryInstitutional: false,
            isOpen: true,
            position: "right",
            uuid: v4(),
            name: "newsletter-subscribe-tray",
            titleKey: "hermes.accessibility.forms.checkout.newsletter.title",
        });

        this.analyticsService.sendData(
            new FooterClickEvent({
                category: "newsletter",
                action: "subscription",
                label: "subscribe_button",
            }),
        );
    }
}
